import { render, staticRenderFns } from "./NgModalDetailOrders.vue?vue&type=template&id=8611f616"
import script from "./NgModalDetailOrders.vue?vue&type=script&lang=js"
export * from "./NgModalDetailOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports